import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import BreadCrumbsComponent from '../breadcumbs/breadcrumbs';
import { Form } from '../dictionary/form';
import { objectUtils } from '@codametrix/ui-common';
const includeHolds = {
    key: 'include_cases_on_holds',
    name: 'include_cases_on_holds',
    label: 'Include Cases on Hold',
    type: 'checkbox',
    isSelected: false
};
const agedCasesDefinition = {
    key: 'cases_older_than',
    name: 'cases_older_than',
    label: 'Definition of Aged Cases',
    placeholder: '0',
    required: true,
    type: 'number',
    readonly: false
};
const maxAllowedDays = {
    key: 'max_allowed_days',
    name: 'max_allowed_days',
    label: 'Max Allowed Backdate Days',
    placeholder: '0',
    required: true,
    type: 'number',
    readonly: false,
    additionalProperties: {
        defaultValue: 30,
        min: 0,
        max: 90
    }
};
const buttons = [
    {
        buttonType: 'submit',
        buttonText: 'Save'
    },
    {
        buttonType: 'link',
        buttonText: 'cancel'
    }
];
const defaultSettings = {
    include_cases_on_holds: false,
    cases_older_than: '',
    allow_backdating: false,
    max_allowed_days: 0
};
export const Features = (props)=>{
    const { handleCancel, errors, handleSave, features } = props;
    const buildData = (features)=>{
        let featuresData = {};
        let value;
        features?.forEach((feature)=>{
            const { configurationKeyname } = feature;
            if ([
                'include_cases_on_holds'
            ].includes(configurationKeyname)) {
                // Convert string booleans to just boolean
                value = feature.value === 'true';
            } else {
                value = feature.value;
            }
            featuresData[configurationKeyname] = value;
        });
        return featuresData;
    };
    const initialSettings = features && features.length > 0 ? buildData(features) : defaultSettings;
    const [selectedSettings, setSelectedSettings] = React.useState(initialSettings);
    const _handleSave = ()=>{
        let configurationValues = [];
        Object.keys(selectedSettings).forEach((keyname)=>{
            const configValue = features?.find((val)=>val.configurationKeyname === keyname);
            if (configValue && configValue.value !== selectedSettings[keyname]) {
                if (configValue.value === 'true' !== selectedSettings[keyname]) {
                    configurationValues.push({
                        ...configValue,
                        value: selectedSettings[keyname]
                    });
                }
            }
        });
        handleSave(configurationValues);
    };
    useEffect(()=>{
        setSelectedSettings(features && features.length > 0 ? buildData(features) : defaultSettings);
    }, [
        features
    ]);
    const ProductivityTracker = {
        label: `ProductivityTracker`,
        fields: [
            includeHolds,
            agedCasesDefinition
        ]
    };
    const TimeEntry = {
        label: `Time Entry`,
        fields: [
            maxAllowedDays
        ]
    };
    const formDefinition = ()=>{
        const formDef = {
            fieldGroups: [
                ProductivityTracker,
                TimeEntry
            ],
            buttons
        };
        return formDef;
    };
    const enableForm = (item)=>{
        return (item.productivity_tracker_enabled ? item.cases_older_than?.length > 0 : true) && !objectUtils.isEqual(item, initialSettings);
    };
    const handleFormChange = (prop, value)=>{
        let settings = {
            ...selectedSettings
        };
        if (prop === 'cases_older_than') {
            settings['cases_older_than'] = value;
        } else if (prop === 'max_allowed_days') {
            settings['max_allowed_days'] = value;
        } else {
            settings[prop] = value !== 'true';
        }
        setSelectedSettings(settings);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(BreadCrumbsComponent, {}),
            /*#__PURE__*/ _jsx(Form, {
                title: 'Features',
                formDefinition: formDefinition(),
                dataItem: selectedSettings,
                enable: enableForm,
                errors: errors,
                inline: false,
                onAction: handleCancel,
                onSave: _handleSave,
                onPropChange: handleFormChange
            })
        ]
    });
};
